import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  Image,
} from "@react-pdf/renderer";
import logoAzul from "../../../images/logoAzul.png";
import bank2Fill from "../../../images/pdfIcons/bank2-fill.png";
import fileTextFill from "../../../images/pdfIcons/file-text-fill.png";

const getCurrentDate = () => {
  const now = new Date();
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const spanishDate = now.toLocaleDateString('es-ES', options);
  
  return spanishDate
}

const styles = StyleSheet.create({
  page: {
    padding: 30,
    position: "relative",
    fontSize: 10,
  },
  pinkColor: {
    color: "#e658c5",
    fontWeight: "bold",
  },
  table: {
    display: "table",
    width: "auto",
    marginTop: 20,
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
  },
  tableColHeader: {
    width: "100%",
    backgroundColor: "#0071ce",
    color: "white",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    textAlign: "center",
    padding: 5,
  },
  tableCol: {
    width: "100%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    padding: 5,
  },
  watermark: {
    position: "absolute",
    top: "40%",
    left: "25%",
    opacity: 0.1,
    transform: "rotate(-30deg)",
    width: 300,
  },
  boldText: {
    fontWeight: "bold",
  },
});

const FormPDF = ({ data, orderData }) => {
  const rowsPerPage = 25;
  const totalCustomers = data.length;

  const chunkedData = [];
  for (let i = 0; i < data.length; i += rowsPerPage) {
    chunkedData.push(data.slice(i, i + rowsPerPage));
  }

  return (
    <Document>
      {chunkedData.map((chunk, pageIndex) => (
        <Page key={pageIndex} size="A4" style={styles.page}>
          <Image src={logoAzul} style={styles.watermark} />
          {pageIndex === 0 && (
            <>
              <Text style={[styles.boldText, { marginBottom: 10 }]}>
                Faltantes de talle:
              </Text>
              <Text>
                <Image
                  src={fileTextFill}
                  style={{ width: 10, height: 10, marginRight: 5 }}
                />{" "}
                Pedido <Text style={styles.pinkColor}>#{orderData.order.code}</Text>
              </Text>
              <Text>
                <Image
                  src={bank2Fill}
                  style={{ width: 10, height: 10, marginRight: 5 }}
                />{" "}
                {orderData.school.name}{" "}
                {orderData.school.alias && `(${orderData.school.alias})`}
              </Text>
              <Text style={{ marginTop: 5 }}>
                Total de talles faltantes:{" "}
                <Text style={styles.pinkColor}>{totalCustomers}</Text>
              </Text>
            </>
          )}

          <View style={styles.table}>
            <View style={styles.tableRow}>
              <Text style={styles.tableColHeader}>Nombre</Text>
              <Text style={styles.tableColHeader}>Artículo</Text>
              <Text style={styles.tableColHeader}>N°</Text>
            </View>

            {chunk.map((row, i) => {
              const itemWithAlias = row.itemAlias
                ? `${row.itemName} (${row.itemAlias})`
                : row.itemName;
              return (
                <View key={i} style={styles.tableRow}>
                  <Text style={styles.tableCol}>{row.name}</Text>
                  <Text style={styles.tableCol}>{itemWithAlias}</Text>
                  <Text style={styles.tableCol}>{row.pending}</Text>
                </View>
              );
            })}
          </View>
        </Page>
      ))}
    </Document>
  );
};

const ExportPDF = ({ data, orderData }) => (
  <PDFDownloadLink
    document={<FormPDF data={data} orderData={orderData} />}
    fileName={`Faltantes de talles ${orderData.order.code} ${getCurrentDate()}`}
  >
    {({ loading }) => (loading ? "Generando PDF..." : "Descargar PDF")}
  </PDFDownloadLink>
);

export default ExportPDF;
